import HeaderCell from './HeaderCell';
import HeaderRowWrapper from './HeaderRowWrapper';
import { IColumn, ISortChange } from '../interfaces';

interface IProps {
  columns: IColumn[],
  sortBy?: string,
  sortOrder?: string,
  onSortChange?: ISortChange,
}

const HeaderRow = ({
  columns,
  sortBy,
  sortOrder,
  onSortChange,
}: IProps) => (
  <HeaderRowWrapper>
    {
      columns.map(({ CustomHeadCell, ...column }) => (
        CustomHeadCell ? (
          <CustomHeadCell
            sortBy={ sortBy }
            sortOrder={ sortOrder }
            onSortChange={ onSortChange }
            key={ column.name }
            { ...column }
          />
        ) : (
          <HeaderCell
            sortBy={ sortBy }
            sortOrder={ sortOrder }
            onSortChange={ onSortChange }
            key={ column.name }
            { ...column }
          />
        )
      ))
    }
  </HeaderRowWrapper>
);

export default HeaderRow;
